import { Injectable } from '@angular/core';
import { ToastrService } from "ngx-toastr";

@Injectable()
export class NotificationService {
    private errorHeader: string = 'Error';  //TODO: localize
    private warningHeader: string = 'Warning';
    private successHeader: string = 'Success';
    private infoHeader: string = 'Info';

    constructor(private notifier: ToastrService) {
    }

    public showError(errorText: string): void {
        if (errorText && errorText.lastIndexOf('<!DOCTYPE html', 0) === 0) {
            this.notifier.error('unknown error', this.errorHeader, {
                timeOut: 12000,
                extendedTimeOut: 8000,
                progressBar: true,
                tapToDismiss: true
            });
            console.error('unknown error');
        } else {
            this.notifier.error(errorText, this.errorHeader, {
                timeOut: 12000,
                extendedTimeOut: 8000,
                progressBar: true,
                tapToDismiss: true
            });
            console.error('Error: ' + errorText);
        }
    }

    public showWarning(text: string): void {
        this.notifier.warning(text, this.warningHeader, {
            timeOut: 12000,
            extendedTimeOut: 8000,
            progressBar: true,
            tapToDismiss: true
        });
    }

    public showSuccess(text: string, header: string = this.successHeader, timeout: number = 8000): void {
        this.notifier.success(text, header, {
            timeOut: timeout,
            extendedTimeOut: 6000,
            progressBar: true,
            tapToDismiss: true
        });
    }

    public showInfo(text: string): void {
        this.notifier.info(text, this.infoHeader, {
            timeOut: 12000,
            extendedTimeOut: 6000,
            progressBar: true,
            tapToDismiss: true
        });
    }
}
